export default __webpack_public_path__ + "static/img8-8cbad58191342ccacea489a0c3f3c727.png";